import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DetailWisata from './pages/DetailWisata';
import Event from './pages/Event';
import Explore from './pages/Explore';
import Kontributor from './pages/Kontributor';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import WisataBudaya from './pages/WisataBudaya';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/wisatabudaya" element={<WisataBudaya />} />
        <Route path="/event" element={<Event />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/detail-wisata" element={<DetailWisata />} />
        <Route path="/kontributor" element={<Kontributor />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
